<template>
	<keep-alive :include="include">
		<router-view />
	</keep-alive>
</template>


<script>
	export default {
		name: 'user-layout',
		data() {
			return {
				include: ['user-list']
			};
		}
	};
</script>